var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 512,
    width: 512,
    id: "flag-icon-css-pn",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-15-7.5h30v15h-30z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M-15-15h30v30h-30z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "translate(256 256) scale(17.06667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-15-15h60v30h-60z",
    fill: "#00247d"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)",
    transform: "translate(0 -7.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 20,
    fill: "#00247d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-20-10l40 20m-40 0l40-20",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-20-10l40 20m-40 0l40-20",
    stroke: "#cf142b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0l20 10h-3L-3 0m3 0l20-10h3L3 0M0 0l-20 10h-3L-3 0m3 0l-20-10h3L3 0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-20 0h40M0-10v20",
    stroke: "#fff",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-20 0h40M0-10v20",
    stroke: "#cf142b",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-.267 3.844c-.64.543-1.25 1.334-1.4 2.05-.421 2.013-.98 2.46-1.846 2.029 0 1.08.948 1.164 1.364.532 0 1.014.368 1.894 1.198 2.644.349.316.415.1.25-.25-.167-.349-.167-1.48-.5-2.128.532.382 1.314.166 1.247-.882-.681.4-1.36.384-1.43-.565-.083-1.114.352-2.731 1.117-3.43zm-.809-8.01c.045-.4-.04-.81-.332-1.067-.564-.497-1.116-.332-1.528.068-.615-.333-.942.847-1.64.647.116.383.299.549.648.416-.366.333 0 .732-.432 1.13.782.25 1.197-.182 1.164-.93.3.266.765.249 1.015-.05-.416-.133-.418-.495-.25-.832.25-.499 1.422-.48 1.355.618z",
    fill: "#f7e017",
    stroke: "#000",
    strokeWidth: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.729 1.62c-.882.465-2.495.265-2.645-.882C-2.066-.41-.95-.926-.652-1.075c.467-.234.832.183.682.665a.755.755 0 0 0 .383-1.13c.682.049 1.314-.467 1.58-1.198-.24.227-.891.073-1.428.039.166-.183.164-.538.114-.721-.566.582-1.38.316-2.461 1.996.166-.583.482-1.747.665-2.512a1.89 1.89 0 0 0 .04-.23c.067-1.098-1.103-1.117-1.353-.618.274.308.13.668.032 1.214-.116.649-.366 2.146-.582 2.645-.067-.782-.582-.832-.682-1.215-.15.1-.233.366-.2.55-.182-.2-.815.05-1.047-.25-.25.499.15.998.565 1.214-.241.017-.3.308-.565.308.357.415.723.582 1.147.615.424.033.74.191.998.707.416.831 2 1.372 3.493.615z",
    fill: "#337321",
    stroke: "#000",
    strokeWidth: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.924.605C2.425 1.985 1.061 2.966.446 3.116c-1.047.255-3.183 1.291-3.757 1.825",
    fill: "#f7e017",
    stroke: "#000",
    strokeWidth: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.267 3.844c-.79.67-1.2 2.316-1.117 3.43.023.31.11.52.242.649.058-.632.498-2.265 1.62-2.994.949-.616 2.43-1.996 2.978-3.576-.1-.283-.266-.482-.582-.682C2.33 2.162.872 2.877-.266 3.844z",
    fill: "#337321",
    stroke: "#000",
    strokeWidth: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.418-.036C2.135.388 1.495.971.879 1.204a.806.806 0 0 0 .183-.5c-.782.3-2.345.267-2.977.034A4.06 4.06 0 0 0 2.11-.46c.133.15.25.283.308.424z",
    fill: "#316d3a",
    stroke: "#000",
    strokeWidth: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.562 3.449c-1.271 1.19-.432 2.228.067 2.461-.133.832.648.732.632 1.43.316-.183.399-.665.349-1.048.399.433 1.414-.05 1.63.749.133-.882-.55-1.763-1.397-1.68.35-.316.15-.831-.183-.965-.067.65-.798.65-1.081.45-.283-.2-.516-.849-.017-1.398z",
    fill: "#337321",
    stroke: "#000",
    strokeWidth: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.809 11.015c-.138.08-.128.258-.041.374.174.233-.123.76.44.873.167.034.295-.068.358-.258.175-.524-.382-.582-.432-.831-.05-.25-.208-.225-.325-.158z",
    fill: "#f7e017",
    stroke: "#000",
    strokeWidth: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.336 11.997c-.186.086-.349.208-.274.806.03.248.017.848-.2.857.133.066.416.137.533-.017.112.187.366.133.465-.1.133.108.316-.074.316-.232.117.074.35-.034.291-.391.142.05.325-.05.391-.142-.208-.041-.731-.324-.856-.548-.125-.225-.45-.333-.666-.233z",
    fill: "#f7e017",
    stroke: "#000",
    strokeWidth: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.217-4.824a2.17 2.17 0 0 1 .282-.341m2.883 2.543c.147-.084.37-.093.618-.077m-.842 16.342c-.059-.083-.08-.432-.038-.645m.504.546",
    strokeWidth: 0.03,
    fill: "none",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.464 3.465c2.046 1.713 2.179 3.077 1.863 3.876-.167-.749-1.015-1.913-1.897-2.212l.034-1.664z",
    fill: "#f7e017",
    stroke: "#000",
    strokeWidth: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.804 2.5h3.793v4.491c0 3.826-2.13 6.087-4.291 7.285C2.143 13.078.015 10.816.015 6.99V2.5h2.66c.005.233.026.582.3.931.628-.062 1.339-.532 1.83-.931z",
    fill: "#337321",
    stroke: "#000",
    strokeWidth: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.596 2.5v4.491c0 1.155-.194 2.167-.524 3.05l-3.766-6.91-3.766 6.91C.21 9.159.016 8.147.016 6.992v-4.49h8.582z",
    fill: "#006ec7",
    stroke: "#000",
    strokeWidth: 0.03
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#f7e017",
    stroke: "#000",
    strokeWidth: 0.03
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.018 12.172c.1.05.284.142.367.175.2-.4.233-.964.166-1.464-.216.55-.948.533-1.147.865.122.062.236.142.334.213-.25.25-.833.669-1.166.769V9.162c0-.25-.083-.457-.083-.665v-.738c0-.166-.033-.407-.183-.407s-.183.241-.183.407v.738c0 .208-.083.449-.083.665v3.568c-.183-.533-.9-.35-1.232-.883a.944.944 0 0 1 .4-.015c-.25-.849-.931-.915-1.064-1.165 0 .35-.15 1.165.083 1.514a.926.926 0 0 1 .225-.185c.283.616 1.554.617 1.854 1.632.24-.373 1.106-.806 1.712-1.456z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.305 9.203c.283 0 1.181-.092 1.505-.092.085 0 .154-.126.154-.282 0-.156-.07-.282-.154-.282-.324 0-1.222-.092-1.505-.092-.283 0-1.18.092-1.505.092-.084 0-.153.126-.153.282 0 .156.069.282.153.282.325 0 1.223.092 1.505.092zm-.182-1.462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.801 9.111c.084 0 .153-.126.153-.282 0-.156-.069-.282-.153-.282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.926 9.111c.085 0 .153-.126.153-.282 0-.156-.068-.282-.153-.282m.821.623c.102 0 .184-.153.184-.341 0-.188-.082-.34-.184-.34m.192.696c.106 0 .193-.16.193-.356 0-.196-.087-.356-.193-.356m.638.716c.108 0 .195-.161.195-.36 0-.199-.087-.36-.195-.36m.201.708c.107 0 .193-.156.193-.348 0-.192-.086-.348-.193-.348m.892.636c.086 0 .156-.13.156-.288 0-.158-.07-.288-.156-.288m-3.22 3.456c.104-.063.226-.117.357-.15m3.029.183l-.098-.07m.28.212c.233-.25.427-.533.533-.856"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 0.03
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.544 5.675c0-.08.066-.116.144-.174.094-.071.131-.104.216-.104h1.092c.08 0 .1.02.1.095v1.485c0 .075-.02.095-.1.095H3.544V5.661",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.726 7.201c.144 0 .118-.003.219-.104.105-.105.095-.095.095-.192V5.548c0-.07-.017-.09-.093-.09h-1.01c-.079 0-.113.031-.2.098-.072.055-.132.087-.132.163V7.2h1.121z",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.833 7.17c0 .075-.019.096-.1.096H3.642c-.081 0-.099-.021-.099-.096V5.686c0-.075.018-.096.099-.096h1.091c.081 0 .1.02.1.096V7.17z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.95 1.631a.837.837 0 0 1 .167.868H6.8c.133-.399.05-.78-.516-.83-.846-.074-1.83 1.564-3.31 1.763-.432-.515-.409-1.498.14-1.963C2.83.65 2.232-.25 1.817-.638",
    fill: "#96877d",
    stroke: "#000",
    strokeWidth: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.26 2.067C3.188.96 2.74.046 2.11-.576c.299.083.914.083 1.33-.216.549-.366 1.98-1.007 2.503-.732.042.091.067.3.033.432-.124-.332-1.505.183-1.896.341-.374.175-.54.408-.407.932-.216-.183-.142-.358-.366-.491.091.216.166.607.191.923-.083-.225-.233-.707-.557-.99.283.55.528 1.867.412 2.566.224 0 .72-.22.919-.378-.175.249-.678.424-1.002.49-.146.175-.246.624-.237.873-.025-.307.072-1.057.227-1.106zm3.69-.436c-.275-.307-.79-.473-1.447-.294.1-.05.316-.134.508-.167C5.986.996 5.828.247 5.803.064l.183-.075c.091.45.207.965.282 1.173.059.017.192.041.308.1-.05-.175-.333-1.43-.324-1.564l.25-.133c.099.682.257 1.672.448 2.066z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8 2.5c.134-.4.05-.781-.515-.831-.438-.039-.914.387-1.476.83H6.8zM3.125-1.084c-.25.034-.807-.016-1.09-.108.017-.075.046-.153.083-.235-.174.117-.507.343-.631.501.4.084 1.223.125 1.638-.158z",
    strokeWidth: 0.03,
    fill: "#96877d",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.116 1.469c.091.265.151.521.16.749m-.915-4.066c-.15.22-.282.456-.325.656.283.092.84.142 1.09.108",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.817-.638c.108.017.208.038.293.062.3.083.915.083 1.33-.217.415-.3 1.548-1.23 2.828-1.33",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.486-.926c.4.084 1.223.125 1.638-.158.965-.657 1.896-1.039 2.827-1.089",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.464 3.465c1.397.965 2.428 1.896 2.727 3.393.3 1.497.865 1.896 1.564 1.497-.166.865-1.031.965-1.763.3.066.997-.333 2.195-1.364 2.627-.066-.598.33-1.073.216-1.563-.05-.216-.066-.715.216-.948-.548.183-1.413-.166-1.496-.981.632.3 1.447.349 1.763-.45.316-.799.183-2.161-1.863-3.875zm1.762-7.783c.432-1.131 1.564-1.015 1.946-.532 1.114-.632 1.264.798 2.212.515-.017.266-.333.516-.682.499.366.333-.15.832.632 1.131-.665.333-1.597-.017-1.846-.931-.216.432-.998.432-1.314.083.682-.183.632-.815.25-1.065-.386-.25-1.065-.15-1.198.3zm-3.373 2.49C7.163-.827 7.805.104 8.497.738c.798.732 2.004.549 2.678-.15.016 1.393-1.426 1.501-2.229 1.065-.354-.193-.64-.092-.3.216.516.465 1.644.812 2.978 1.097 2.328.5 1.497 2.345.815 2.329.195-.004.356-.209.075-.462-2.021-1.817-6.13-1.102-6.063-5.16C6.02.738 4.24.323 5.071-.942c.266.216.732.233.865-.1.103-.259.036-.709-.43-1.096.076-.006.24 0 .224-.19.02.112.123.278.384.222.075.118.154.196.26.154.021-.009.084-.04.059-.158.02.22.282.3.42.282z",
    fill: "#337321",
    stroke: "#000",
    strokeWidth: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.946 1.652c.965.632 2.056.632 3.06-.532.317-.366.816-.682 1.165-.715.349-.033.332-.366.599-.432-.167-.05-.233-.25-.483-.225.624-.216.441-.715.749-.956-.25.091-.64-.283-.998.191.091-.216-.034-.474-.125-.574.033.25-.49.3-.59.932-.056.354-.25.332-.283-.217-.025-.401-.216-1.513-.45-2.078-.232-.566-.285-1.342.03-1.459M9.28 11.942c.204.105.38.247.271.913-.045.275-.055.945.186.964-.152.069-.47.135-.594-.041-.133.203-.414.132-.515-.132-.154.115-.35-.097-.343-.274-.133.079-.388-.052-.308-.449-.16.05-.36-.07-.43-.175.234-.037.831-.33.98-.575.15-.245.516-.352.753-.23z",
    fill: "#f7e017",
    stroke: "#000",
    strokeWidth: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.143 13.778c.068-.09.107-.48.07-.718m-.586.588a1.1 1.1 0 0 0 .352-.572m-.695.297c.132-.055.464-.451.544-.713m-.852.264c.155-.027.636-.315.843-.632",
    strokeWidth: 0.03,
    fill: "none",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.45-.327c-.027 1.705.682 2.568 1.663 3.13-.365-.22-.207-.968-.698-1.209.117-.008.3.158.591.092-.141-.316-.374-.799-.915-.865.142-.017.45.033.649-.042C7.457.347 6.709.555 6.45-.327zm-.177-1.621c-.06-.02-.11-.08-.16-.158-.262.056-.364-.11-.385-.223.017.191-.148.184-.225.19.468.388.535.838.431 1.097-.133.333-.598.316-.865.1-.033.707.882.94 1.215.05 0 .15.19.133.24.332.238-.382.059-.931-.25-1.388z",
    fill: "#f7e017",
    stroke: "#000",
    strokeWidth: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.814-5.325c-.416-.382-.607-1.022-.59-1.388.016-.366.166-.765.698-.599-.166 0-.05.333-.225.366.142.05.333-.067.358-.141.033.116.25.083.266.216.083-.067-.008-.391-.133-.458.091-.05.141-.307.1-.432-.083.017-.208.133-.233.3.042-.134-.008-.466-.241-.516a.44.44 0 0 0 .008.44c-.216-.05-.532.092-.607.275.017-.22.047-.534.183-.732.046-.066-.067-.183-.154-.025-.162-.316-.594-.482-.786-.324-.192.158-.449-.075-.607.174-.158.25-.693.276-.665.541.017.158-.022.402-.1.49-.191.217.092.375.142.566-.034-.632.973-1.863 1.979-1.38-.092.158-.172.473-.2.856-.041.566.042 1.364.59 1.83l.217-.059z",
    fill: "#337321",
    stroke: "#000",
    strokeWidth: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.112-7.304c-.005-.15.254-.344.603-.34.42.004.744.386 1.08.349.336-.037.171.15.1.2-.07.05-.111.124-.087.215.024.091-.018.152-.153.067-.3-.187-.6.075-.994-.07-.343-.127-.54-.196-.549-.42z",
    fill: "#cf142b",
    stroke: "#000",
    strokeWidth: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.4-3.379c-.167-.524-.799-1.097-1.107-1.23l-.016-.283c.166-.067.565-.383.748-.557 1.248.598 2.944-.25 3.726-1.131l.3.183-.15.2-.159-.084c-.19.233-.905.905-1.121 1.046.29.074.688.124.797.118.699-.499 1.247-.948 1.514-.981l.224.3-.2.14-.157-.09c-.749.615-1.597 1.962-1.93 2.86-.465-.1-2.129-.033-2.47-.49z",
    fill: "#96877d",
    stroke: "#000",
    strokeWidth: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.466-3.562c-.112-.62.066-1.305.382-1.513.69.457 1.871.457 2.57-.042",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.466-3.886c.532-.017 1.688.075 1.97.117.283.041.757.158.69.299m-2.414-.504l.153-.153-.153-.153-.153.153.153.153z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.074-7.07c-.192-.267-.719-.351-.832.007-.05.158-.125.325-.25.4-.124.074-.095.301-.041.399.133.24.017.474.274.632 0-.192.283-.391.524-.441.241-.05.607-.266.657-.507.05-.241.133-.441-.332-.49z",
    fill: "#337321",
    stroke: "#000",
    strokeWidth: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.874-4.676h.067l.001.455a.117.117 0 0 1 .04.02l.391-.225.034.057-.394.229a.12.12 0 0 1 .002.045l.392.226-.034.058-.394-.227",
    fill: "#96877d",
    stroke: "#000",
    strokeWidth: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.468-3.564a.788.788 0 1 1 .068-1.033c-.041.1-.088.322-.092.423",
    fill: "#96877d",
    stroke: "#000",
    strokeWidth: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.576-2.813c-.05-.058-.14-.216-.133-.333a.432.432 0 0 1 .283.108c-.008-.083-.041-.266-.025-.349.092.033.283.141.35.266-.017-.083-.05-.3-.017-.432.1.058.266.216.3.324.007-.166.066-.44.116-.507.074.075.19.141.266.24.016-.132.083-.29.183-.332a.963.963 0 0 1 .216.491c.075-.025.175-.15.216-.216a.466.466 0 0 1 .058.324c.092-.083.2-.2.225-.3.066.05.191.175.224.308-.016-.108-.008-.299-.041-.407a.48.48 0 0 1 .25.308c.033-.117.107-.325.174-.375.066.133.133.291.125.424.041-.083.108-.232.174-.266.058.092.05.291.033.4a.806.806 0 0 1 .233-.217.65.65 0 0 1 0 .225c.075-.042.2-.266.241-.383.117.059.233.258.242.358a.91.91 0 0 0 .299-.266c0 .058.025.216-.008.34.05-.05.1-.149.125-.19.033.083.008.282-.026.39a.435.435 0 0 1 .25-.108c.008.142-.092.391-.183.574-.798-.225-2.47-.308-4.15-.4z",
    fill: "#337321",
    stroke: "#000",
    strokeWidth: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.36-7.219c-.004-.061.133-.2.378-.198.294.001.565.217.801.202.236-.015.12.06.07.081-.05.02-.079.051-.061.089.018.038-.013.062-.108.027-.21-.077-.419.03-.695-.029-.24-.052-.379-.08-.385-.172z",
    fill: "#f7e017"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 0.03
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.834-2.314c-.25.3-.499.25-.549.058-.05-.191.134-.283.067-.45-.067-.165.108-.24.191-.165.083.074.35-.167.466.083.116.25.208.424.141.524-.066.1-.266.05-.316-.05zm1.072-.449c-.047-.11.212-.32.345-.17.133.149.34-.163.457.074.117.237.154.362.212.495.059.133-.316.204-.432.087.017.08-.323.141-.416-.083-.05-.12-.104-.258-.166-.403zm1.731.137c-.062-.116.241-.283.4-.07.04-.088.34-.105.361.149.02.254.03.403.037.503.007.1-.182.191-.32-.062-.245.05-.357-.088-.386-.233a1.118 1.118 0 0 0-.092-.287z",
    fill: "#f7e017"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.995-2.792c-.037-.083.212-.25.382-.125.171.125.407-.108.508.116.203.454.216.487.154.574-.063.087-.329.054-.395-.066-.013.083-.242.07-.362.004-.137-.075-.233-.354-.287-.503zm1.75.02c-.058-.128.333-.24.503-.016.088-.08.28-.083.387.162.108.245.125.383.046.445-.056.044-.258.079-.324-.033-.092.058-.375.008-.437-.15a4.365 4.365 0 0 0-.175-.408zm1.656.246c-.008-.117.204-.17.283 0 .079.17.332.017.353.3.004.053-.029.261-.108.36-.079.099-.465 0-.49-.211",
    fill: "#337321"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.834-2.314c-.091-.125-.216-.325-.374-.108m1.185.129",
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPn);
export default __webpack_public_path__ + "static/media/pn.35a3a02fae83b674fec1a87189355a76.svg";
export { ForwardRef as ReactComponent };